"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _shortId = _interopRequireDefault(require("./shortId"));

var _react = require("react");

var _default = function _default(defaultId) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      uniqueId = _useState2[0],
      setUniqueId = _useState2[1];

  if (defaultId) return defaultId;
  if (uniqueId) return uniqueId;

  var id = _shortId.default.generate();

  setUniqueId(id);
  return id;
};

exports.default = _default;